import httpClient from "./httpClient";

export const getChannelMetrics = (channelId, params) =>
  httpClient.get(`/channel/${channelId}/metric`, { params });
